import * as React from 'react';
import { DeveloperInviteModel, DeveloperModel, DeveloperRole } from '@journeyapps-platform/lib-journey-core';
import { observer } from 'mobx-react';
import * as _ from 'lodash';
import { styled } from '../../../theme';
import { DeveloperInviteStatus } from '@journeyapps-platform/types-accounts-hub';

export type RoleDisplayWidgetProps = {
  developer: DeveloperModel | DeveloperInviteModel;
  filterOrgId?: string;
};

export const RoleDisplayWidget: React.FC<RoleDisplayWidgetProps> = observer((props) => {
  const { developer, filterOrgId } = props;

  if (developer instanceof DeveloperInviteModel) {
    if (developer.model.status === DeveloperInviteStatus.ACCEPTED) {
      return (
        <S.RoleContainer>
          {developer.appliedRoles?.map((r) => {
            return <S.FeaturePill key={r.id}>{r.options.role.name}</S.FeaturePill>;
          })}
        </S.RoleContainer>
      );
    }
    return (
      <S.RoleContainer>
        {developer.model.metadata.role_names?.map((r) => {
          return <S.FeaturePill key={r}>{r}</S.FeaturePill>;
        })}
      </S.RoleContainer>
    );
  }

  return (
    <S.RoleContainer>
      {_.chain(developer.roles.items)
        .map((r) => (r as DeveloperRole).role)
        .filter((roleModel) => !filterOrgId || roleModel.options.role.org_id == filterOrgId)
        .map((roleModel) => <S.FeaturePill key={roleModel.id}>{roleModel.options.role.name}</S.FeaturePill>)
        .value()}
    </S.RoleContainer>
  );
});

namespace S {
  export const RoleContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    column-gap: 5px;
    row-gap: 5px;
    min-width: 200px;
  `;
  export const FeaturePill = styled.div`
    padding: 5px 10px;
    background: rgba(53, 53, 53, 0.7);
    color: ${(p) => p.theme.text.secondary};
    border-radius: 15px;
    font-size: 12px;
    display: inline-block;
    white-space: nowrap;
  `;
}
